const SpanError = (props) => {
  return <span className="text-sm text-red-700">{props.children ? props.children : "Este campo es obligatorio"}</span>;
};

export default SpanError;
